// React
import { ReactElement, useRef } from 'react';
// Context
import { useQualifiers } from '@utmb/contexts/QualifiersContext';
// Design System
import { Pagination } from '@utmb/design-system/pagination/Pagination';
import { DisplayListResult } from '@utmb/design-system/display-list-result/DisplayListResult';
import { QualifiersLoader } from '@utmb/features/qualifiers/qualifiers-loader/QualifiersLoader';
// Features
import QualifiersCards from '@utmb/features/qualifiers/qualifiers-cards/QualifiersCards';
// Interfaces
import SearchQualifiersRaceView from '@utmb/types/view/SearchQualifiersRaceView';
// Styles
// import styles from './qualifiers-cards.module.scss';

export const QualifiersList = (): ReactElement => {
    const { changePageQualifiers, isLoaded, races, limit = 0, nbHits, offset } = useQualifiers();

    // Limit could be undefined as it is defined by the API
    let currentPage = offset / limit;

    if (isNaN(currentPage)) {
        currentPage = 0;
    }

    const totalPages = Math.ceil(nbHits / limit);

    const ref = useRef<any>();

    function handlePageChange(event: { selected: number }): void {
        changePageQualifiers(event.selected);

        if (ref) {
            window.scrollTo(0, ref.current.offsetTop - 150);
        }
    }

    return (
        <>
            {isLoaded ? (
                <>
                    <div ref={ref}></div>
                    <DisplayListResult hits={nbHits} />

                    <ul className="list-reset">
                        {races &&
                            races.map((race: SearchQualifiersRaceView) => (
                                <li key={race.id} style={{ marginTop: '20px' }}>
                                    <QualifiersCards {...race} />
                                </li>
                            ))}
                    </ul>

                    {totalPages > 1 && <Pagination forcePage={currentPage} PageCount={totalPages} onPageChange={handlePageChange} />}
                </>
            ) : (
                <QualifiersLoader limit={limit} />
            )}
        </>
    );
};
